import styled from 'styled-components';

const ButtonGroup = styled.div`
  display: inline-flex;
  margin-right: 10px;

  > *:not(:first-child) {
    margin-left: -1px;
  }

  ${(props) =>
    props.group &&
    `
    > * {
      border-radius: 0;
      
      &:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
      }
      
      &:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
      }
    }
  `}
`;

export default ButtonGroup;
